function onRcWidgetLoad() {
  const productPrice = '$' + (window.__ha.product.price / 100).toFixed(2);
  // Select all .rc-radio label elements within .rc-widget
  const radioLabels = document.querySelectorAll('.rc-widget .rc-radio');

  radioLabels.forEach(label => {
    // Check if the label is a one-time radio button
    const isOneTimeRadio = label.classList.contains('onetime-radio');
    const priceElement = label.querySelector('.rc-radio__price');
    if (priceElement || isOneTimeRadio) {
      const targetDiv = label.querySelector('.rc-radio__label');
      let priceText = '';

      if (isOneTimeRadio) {
        // Extract text and price for one-time radios
        const textContent = targetDiv.textContent.trim();
        const priceMatch = textContent.match(/(\$[\d,.]+)/);
        if (priceMatch) {
          priceText = priceMatch[0];
          const textWithoutPrice = textContent.replace(priceText, '').trim();

          // Clear the existing content
          targetDiv.textContent = '';

          // Create and add the new price div
          const newPriceDiv = document.createElement('div');
          newPriceDiv.className = 'price-styling';
          newPriceDiv.textContent = priceText + ' '; // Add a space for separation
          targetDiv.appendChild(newPriceDiv);

          // Add back the text without the price
          const newTextSpan = document.createElement('span');
          newTextSpan.textContent = textWithoutPrice;
          targetDiv.appendChild(newTextSpan);
        }
      } else if (priceElement) {
        // Handle non-one-time radios (original logic)
        const priceDiv = document.createElement('div');
        priceDiv.textContent = 'Now ' + priceElement.textContent + ' ';
        priceDiv.className = 'price-styling';

        const originalPriceDiv = document.createElement('div');
        originalPriceDiv.className = 'rc-widget-original-price';
        originalPriceDiv.innerHTML = productPrice;
        priceDiv.prepend(originalPriceDiv);

        targetDiv.insertBefore(priceDiv, targetDiv.firstChild);
        priceElement.remove();
      }

      // Remove the last <br> and everything after it, if any
      const brElements = targetDiv.querySelectorAll('br');
      if (brElements.length > 0) {
        const lastBr = brElements[brElements.length - 1];
        while (lastBr.nextSibling) {
          lastBr.parentNode.removeChild(lastBr.nextSibling);
        }
        lastBr.parentNode.removeChild(lastBr);
      }
    }
  });
}


// Check if .rc-widget already exists in the DOM
const existingWidget = document.querySelector('.rc-widget');
if (existingWidget) {
  // If the widget already exists, call the function immediately
  onRcWidgetLoad();
} else {
  // If the widget does not exist, use MutationObserver to wait for its addition
  const observer = new MutationObserver((mutations, obs) => {
    const widget = document.querySelector('.rc-widget');
    if (widget) {
      onRcWidgetLoad();
      // Once the widget is found, there's no need to keep observing for changes
      obs.disconnect();
    }
  });

  // Start observing the document body for added nodes
  observer.observe(document.body, {
    childList: true, // observe direct children
    subtree: true, // and lower descendants too
  });
}
